//@import "bootstrap-sass/assets/javascripts/bootstrap.js";

import Materialize from 'materialize-css';
import Slick from 'slick-carousel';
//import Isotope from 'isotope-layout';
//import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic.js';
//import ScrollMagicInit from 'modules/scrollfire/init';

// vendor
require('./vendor/fancybox-init');
require('./vendor/jquery-confirm');
require('./vendor/select2.min');
// require('./vendor/dropzone');
import Dropzone from './vendor/dropzone';

// modules
require('./modules/header/');
require('./modules/header/logo');
require('./modules/slider/');
require('./modules/maps/filter-map');
require('./modules/maps/single-map');
require('./modules/filter/tabs');
require('./modules/filter/filter');
require('./modules/filter/sticky');
require('./modules/scroll/init');
require('./modules/tabs/');
require('./modules/overlay/');
require('./modules/securearea/');
require('./modules/securearea-next/');
require('./modules/animation/svg-animation');
require('./modules/form/');
require('./modules/login-modal/');
require('./modules/breadcrumb/');
require('./modules/courses/');
require('./modules/mxm_forum/');

// special
//require('./modules/browserdetection.js');
// require('./modules/test.js');

// init global materialize stuff
$(document).ready(function() {

	$('.collapsible').collapsible();

	// inject the close button
	var backbtn = $('.category-back, #page-closer');
	var title = $('.line-container > .row:first-child .intro-title');

	if(backbtn.length && title.length){
		title.append('<a href="'+backbtn.data('link')+'" class="title-back" id="page-closer"><div class="cssicon close"></div></a>');
	}

	$(document).on('click', '.category-back', function (e) {
		e.preventDefault();
		history.back() ;
	});
});



/** WEBPACK FOOTER **
 ** ./Frontend/js/app.js
 **/